import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { ArrowRight, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPendenciaMovida = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('pendência movida para') || 
           acaoLower.includes('pendencia movida para') ||
           acaoLower.includes('movida para');
};

const getIconPendenciaMovida = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: ArrowRight, color: 'var(--c8041c7)' };
};

export default function CardPendenciaMovida({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconPendenciaMovida(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const pendenciaMovidaConfig = {
    tipo: 'pendencia_movida',
    detectaTipo: detectaPendenciaMovida,
    getIcon: getIconPendenciaMovida,
    temExpansao: () => true,
    Component: CardPendenciaMovida
};

